import { ParticipantCardActionsType } from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/ParticipantCardActions.type';
import { ParticipantCardDamagesMappedType } from '@/modules/adjusterReportModules/IncidentParticipants/types/ParticipantCardDamagesType';
import ParticipantIncidentActivate from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/components/participantIncidentActivate/ParticipantIncidentActivate';
import ParticipantIncidentDeactivate from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/components/participantIncidentDeactivate/ParticipantIncidentDeactivate';
import DamagedListEntry from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/components/participantIncidentEntry/DamagedListEntry';
import { TabStateType } from '@/modules/adjusterReportModules/IncidentParticipants/types/ParticipantType';

const ParticipantCardActions = ({
  file,
  type,
  state,
}: ParticipantCardActionsType & TabStateType) => {
  const ActionComponentsMapper = {
    activate: (
      <ParticipantIncidentActivate
        key={'ParticipantIncidentActivate'}
        id={file.id}
      />
    ),
    diactivate: (
      <ParticipantIncidentDeactivate
        key={'ParticipantIncidentDeactivate'}
        id={file.id}
        name={
          (file as ParticipantCardDamagesMappedType).owner_type?.const ===
          'real'
            ? `${(file as ParticipantCardDamagesMappedType).real?.first_name ?? ''} ${(file as ParticipantCardDamagesMappedType).real?.last_name ?? ''}`
            : ((file as ParticipantCardDamagesMappedType).legal?.name ?? '')
        }
      />
    ),
    entry: (
      <DamagedListEntry
        state={state}
        hasDivider={
          !(
            (file as ParticipantCardDamagesMappedType)?.action_list?.length ===
              0 ||
            (type === 'damaged' && state === 'image')
          )
        }
        personId={file.id}
      />
    ),
  };
  if (type === 'damaged') {
    if (state === 'image') {
      return ActionComponentsMapper.entry;
    }
    const result = (file as ParticipantCardDamagesMappedType).action_list.map(
      (action: string) => {
        return ActionComponentsMapper[
          action as keyof typeof ActionComponentsMapper
        ];
      },
    );

    if (
      (file as ParticipantCardDamagesMappedType).action_list.some(
        (item) => item === 'activate',
      )
    ) {
      return result;
    } else {
      return result.concat(
        <DamagedListEntry
          state={state}
          key={'ParticipantIncidentEntry'}
          personId={file.id}
          hasDivider={
            (file as ParticipantCardDamagesMappedType)?.action_list?.length > 0
              ? true
              : false
          }
        />,
      );
    }
  }
};
export default ParticipantCardActions;
